import * as actions from './actions';
import { combineReducers } from 'redux';
import {
  WEBSOCKET_CLOSED,
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT,
  WEBSOCKET_OPEN
} from '@giantmachines/redux-websocket';

const ticket = (state = null, action) => {
  switch (action.type) {
    case actions.RTC_TICKET_SUCCESS:
      return action.payload;
    case WEBSOCKET_OPEN:
      return null;
    default:
      return state;
  }
};
const socket = (
  state = {
    loading: null,
    open: null
  },
  action
) => {
  switch (action.type) {
    case WEBSOCKET_CONNECT:
      return {
        ...state,
        loading: true
      };
    case WEBSOCKET_DISCONNECT:
      return {
        ...state,
        loading: true
      };
    case WEBSOCKET_OPEN:
      return {
        ...state,
        loading: false,
        open: true
      };
    case WEBSOCKET_CLOSED:
      return {
        ...state,
        loading: false,
        open: false
      };
    default:
      return state;
  }
};

export default combineReducers({
  ticket,
  socket
});
